var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgrade3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_17234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5518 0.227378L25.3704 2.40882C25.2258 2.55344 25.1445 2.74963 25.1445 2.95413V6.63644L28.8683 1.79138V0.772691C28.8683 0.0856909 28.0377 -0.258372 27.5518 0.227378Z",
    fill: "#AD4F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.227 3.13159H30.2083L25.3633 6.8554H29.0456C29.2502 6.8554 29.4463 6.77415 29.5909 6.62953L31.7723 4.44809C32.2581 3.96228 31.914 3.13159 31.227 3.13159Z",
    fill: "#AD4F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9114 32.0001C6.68925 32.0001 0 25.3108 0 17.0886C0 8.86643 6.68925 2.17725 14.9114 2.17725C23.1336 2.17725 29.8229 8.8665 29.8229 17.0887C29.8229 25.3109 23.1336 32.0001 14.9114 32.0001Z",
    fill: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9114 28.8409C8.43118 28.8409 3.15918 23.5689 3.15918 17.0887C3.15918 10.6085 8.43112 5.33643 14.9114 5.33643C21.3916 5.33643 26.6636 10.6084 26.6636 17.0886C26.6636 23.5688 21.3915 28.8409 14.9114 28.8409Z",
    fill: "#506366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9114 25.6816C10.1732 25.6816 6.31836 21.8268 6.31836 17.0886C6.31836 12.3504 10.1732 8.49561 14.9114 8.49561C19.6495 8.49561 23.5044 12.3504 23.5044 17.0886C23.5044 21.8267 19.6495 25.6816 14.9114 25.6816Z",
    fill: "#6EE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9114 22.5224C11.9152 22.5224 9.47754 20.0848 9.47754 17.0886C9.47754 14.0924 11.9152 11.6548 14.9114 11.6548C17.9075 11.6548 20.3452 14.0924 20.3452 17.0886C20.3452 20.0849 17.9075 22.5224 14.9114 22.5224Z",
    fill: "#FD6F71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9115 19.3635C16.1678 19.3635 17.1862 18.345 17.1862 17.0887C17.1862 15.8324 16.1678 14.814 14.9115 14.814C13.6552 14.814 12.6367 15.8324 12.6367 17.0887C12.6367 18.345 13.6552 19.3635 14.9115 19.3635Z",
    fill: "#FADC60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9113 15.7481C14.5413 16.1182 14.5413 16.7184 14.9113 17.0884C15.2814 17.4585 15.8816 17.4585 16.2516 17.0884L30.2085 3.13157L28.8682 1.79126L14.9113 15.7481Z",
    fill: "#C86D5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_17234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade3);
export default __webpack_public_path__ + "static/media/upgrade_3.21a4608ef86c960bee7fffb4d19f313f.svg";
export { ForwardRef as ReactComponent };